module.exports = __webpack_public_path__ + "static/media/dots.a9bdda17.svg";